import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  providerName: PropTypes.string,
  preferredUsername: PropTypes.string
};

const defaultProps = {
  providerName: 'google',
  preferredUsername: 'DJofNature'
};

class WelcomeBack extends React.Component {

  render() {
    const { onSignIn, onAnotherAccount, preferredUsername } = this.props;

    return (
      <div id="welcome_back" style={{display:"none"}}>
        <div className="login-block">
          <div className="provider">
            <ul className="providers" style={{float:"none"}}>
              <li id="{providerName}"></li>
            </ul>
          </div>
          <div className="content">
            <h1>Welcome back, <span className="user-name">{ preferredUsername }<a className="not-you" onClick={this.wrongUser}><span>not you?</span></a></span></h1>
          </div>
          <a className="sign-in" onClick={onSignIn(providerName)}><span>Sign In &gt;&gt;</span></a>
        </div>
        <div className="login-block-footer">
          <a className="use-another-account" onClick={onAnotherAccount}><span>use another account</span></a>
        </div>
      </div>
    )
  }

}

WelcomeBack.propTypes = propTypes;
WelcomeBack.defaultProps = defaultProps;

export default WelcomeBack;
